import './GanttChartLine.css';
export var wrapper = '_1pk2ed10-3-12-1';